/**
 * Frontend field catalog — must stay in sync with
 * admin-panel-backend/utils/fieldCatalog.js
 */

export const FIELD_CATALOG = [
  {
    entity: 'company',
    label: 'Company',
    color: '#f7fafc',
    fields: [
      { key: 'name', label: 'Name', listAccessors: ['name'], formAccessors: ['name'] },
      { key: 'slug', label: 'Slug', listAccessors: ['slug'], formAccessors: ['slug'] },
      { key: 'is_active', label: 'Status / Active', listAccessors: ['is_active'], formAccessors: ['is_active'] },
      { key: 'gameIds', label: 'Games', listAccessors: ['gameIds'], formAccessors: ['gameIds'] },
      {
        key: 'isseparateresultbygame',
        label: 'Separate Result By Game',
        listAccessors: [],
        formAccessors: ['isseparateresultbygame'],
      },
      {
        key: 'separateResultGameIds',
        label: 'Games for Separate Results',
        listAccessors: [],
        formAccessors: ['separateResultGameIds'],
      },
    ],
  },
  {
    entity: 'game',
    label: 'Game',
    color: '#ebf8ff',
    fields: [
      { key: 'drawNumber', label: 'Draw Number', listAccessors: ['drawNumber'], formAccessors: [] },
      { key: 'gameCode', label: 'Game Code', listAccessors: ['gameCode'], formAccessors: ['gameCode'] },
      { key: 'gameNumber', label: 'Game Number', listAccessors: ['gameNumber'], formAccessors: ['gameNumber'] },
      { key: 'name', label: 'Name', listAccessors: ['name'], formAccessors: ['name'] },
      { key: 'gameType', label: 'Game Type', listAccessors: [], formAccessors: ['gameType'] },
      { key: 'bet', label: 'Bet', listAccessors: ['bet'], formAccessors: ['bet'] },
      { key: 'win', label: 'Win', listAccessors: ['win'], formAccessors: ['win'] },
      { key: 'interval', label: 'Interval', listAccessors: ['interval'], formAccessors: ['interval'] },
      { key: 'drawCalc', label: 'Draw Calc', listAccessors: ['drawCalc'], formAccessors: ['drawCalc'] },
      { key: 'totalCalc', label: 'Total Calc', listAccessors: ['totalCalc'], formAccessors: ['totalCalc'] },
      { key: 'bonus', label: 'Bonus', listAccessors: ['bonus'], formAccessors: ['bonus'] },
      { key: 'high_bonus', label: 'High Bonus', listAccessors: [], formAccessors: ['high_bonus'] },
      { key: 'auto_win_cap_pct', label: 'AUTO Win Cap %', listAccessors: [], formAccessors: ['auto_win_cap_pct'] },
      { key: 'auto_win_frequency_pct', label: 'AUTO Win Frequency %', listAccessors: [], formAccessors: ['auto_win_frequency_pct'] },
      { key: 'startTime', label: 'Start Time', listAccessors: [], formAccessors: ['startTime'] },
      { key: 'endTime', label: 'End Time', listAccessors: [], formAccessors: ['endTime'] },
      { key: 'manual_draw', label: 'Manual Draw', listAccessors: ['manual_draw'], formAccessors: ['manual_draw'] },
      { key: 'manual_times', label: 'Manual Draw Times', listAccessors: [], formAccessors: ['manual_times'] },
      { key: 'autoBlock', label: 'Auto Block', listAccessors: ['autoBlock'], formAccessors: ['autoBlock'] },
      { key: 'checkHighN2P', label: 'Check High N2P', listAccessors: ['checkHighN2P'], formAccessors: ['checkHighN2P'] },
      { key: 'forceX', label: 'ForceX', listAccessors: ['forceX'], formAccessors: ['forceX'] },
      {
        key: 'allowRepeatDigits',
        label: 'Allow Repeat Digits',
        listAccessors: [],
        formAccessors: ['allowRepeatDigits'],
      },
      { key: 'no_more_bet', label: 'No More Bet (sec)', listAccessors: [], formAccessors: ['no_more_bet'] },
      { key: 'single_max_bet', label: 'Single Max Bet', listAccessors: [], formAccessors: ['single_max_bet'] },
      { key: 'patti_max_bet', label: 'Patti Max Bet', listAccessors: [], formAccessors: ['patti_max_bet'] },
      { key: 'allow_adv_booking', label: 'Allow Advance Booking', listAccessors: [], formAccessors: ['allow_adv_booking'] },
      { key: 'patti_win', label: 'Patti Win', listAccessors: [], formAccessors: ['patti_win'] },
      { key: 'is_active', label: 'Status', listAccessors: ['is_active'], formAccessors: [] },
    ],
  },
  {
    entity: 'admin',
    label: 'Admin',
    color: '#faf5ff',
    fields: [
      { key: 'username', label: 'Username', listAccessors: ['username'], formAccessors: ['username'] },
      { key: 'password', label: 'Password', listAccessors: ['password'], formAccessors: ['password'] },
      {
        key: 'company',
        label: 'Company',
        listAccessors: ['company_id', 'company'],
        formAccessors: ['company_id'],
      },
      { key: 'balance', label: 'Balance', listAccessors: ['balance'], formAccessors: [] },
      { key: 'balance_check', label: 'Bal. check', listAccessors: ['balance_check'], formAccessors: [] },
      { key: 'is_active', label: 'Status / Active', listAccessors: ['is_active'], formAccessors: ['is_active'] },
      { key: 'gameIds', label: 'Games', listAccessors: [], formAccessors: ['gameIds'] },
    ],
  },
  {
    entity: 'superStokez',
    label: 'Super Stokez',
    color: '#fff5f5',
    fields: [
      { key: 'username', label: 'Username', listAccessors: ['username'], formAccessors: ['username'] },
      { key: 'password', label: 'Password', listAccessors: ['password'], formAccessors: ['password'] },
      { key: 'admin', label: 'Admin', listAccessors: ['admin_name'], formAccessors: ['admin_id'] },
      { key: 'company', label: 'Company', listAccessors: ['company_name'], formAccessors: ['company_id'] },
      { key: 'balance', label: 'Balance', listAccessors: ['balance'], formAccessors: [] },
      { key: 'game_codes', label: 'Game Codes', listAccessors: ['game_codes'], formAccessors: [] },
      { key: 'gameIds', label: 'Games', listAccessors: [], formAccessors: ['gameIds'] },
      { key: 'isLocked', label: 'Status / Locked', listAccessors: ['isLocked'], formAccessors: [] },
      {
        key: 'commission_perc',
        label: 'Commission %',
        listAccessors: ['commission_perc'],
        formAccessors: ['commission_perc'],
      },
      {
        key: 'target_perc',
        label: 'Target %',
        listAccessors: ['target_perc'],
        formAccessors: ['target_perc'],
      },
      {
        key: 'adminTargetNTP',
        label: 'Admin Target NTP',
        listAccessors: ['adminTargetNTP'],
        formAccessors: ['adminTargetNTP'],
      },
      {
        key: 'isseparateresultbygame',
        label: 'Separate Result By Game',
        listAccessors: [],
        formAccessors: ['isseparateresultbygame'],
      },
      {
        key: 'separateResultGameIds',
        label: 'Games for Separate Results',
        listAccessors: [],
        formAccessors: ['separateResultGameIds'],
      },
    ],
  },
  {
    entity: 'stokez',
    label: 'Stokez',
    color: '#fffaf0',
    fields: [
      { key: 'username', label: 'Username', listAccessors: ['username'], formAccessors: ['username'] },
      { key: 'password', label: 'Password', listAccessors: ['password'], formAccessors: ['password'] },
      {
        key: 'super_stokez',
        label: 'Super Stokez',
        listAccessors: ['super_stokez_name'],
        formAccessors: ['super_stokez_id'],
      },
      { key: 'admin', label: 'Admin', listAccessors: ['admin_name'], formAccessors: ['admin_id'] },
      { key: 'company', label: 'Company', listAccessors: ['company_name'], formAccessors: ['company_id'] },
      { key: 'balance', label: 'Balance', listAccessors: ['balance'], formAccessors: [] },
      { key: 'game_codes', label: 'Game Codes', listAccessors: ['game_codes'], formAccessors: [] },
      { key: 'gameIds', label: 'Games', listAccessors: [], formAccessors: ['gameIds'] },
      { key: 'is_active', label: 'Status', listAccessors: ['is_active'], formAccessors: [] },
      {
        key: 'commission_perc',
        label: 'Commission %',
        listAccessors: ['commission_perc'],
        formAccessors: ['commission_perc'],
      },
      {
        key: 'target_perc',
        label: 'Target %',
        listAccessors: ['target_perc'],
        formAccessors: ['target_perc'],
      },
      {
        key: 'adminTargetNTP',
        label: 'Admin Target NTP',
        listAccessors: ['adminTargetNTP'],
        formAccessors: ['adminTargetNTP'],
      },
    ],
  },
  {
    entity: 'agent',
    label: 'Agent',
    color: '#e6fffa',
    fields: [
      { key: 'username', label: 'Username', listAccessors: ['username'], formAccessors: ['username'] },
      { key: 'password', label: 'Password', listAccessors: ['password'], formAccessors: ['password'] },
      { key: 'stokez', label: 'Stokez', listAccessors: ['stokez_name'], formAccessors: ['stokez_id'] },
      {
        key: 'super_stokez',
        label: 'Super Stokez',
        listAccessors: ['super_stokez_name'],
        formAccessors: ['super_stokez_id'],
      },
      { key: 'admin', label: 'Admin', listAccessors: ['admin_name'], formAccessors: ['admin_id'] },
      { key: 'company', label: 'Company', listAccessors: ['company_name'], formAccessors: ['company_id'] },
      { key: 'balance', label: 'Balance', listAccessors: ['balance'], formAccessors: [] },
      { key: 'game_codes', label: 'Game Codes', listAccessors: ['game_codes'], formAccessors: [] },
      { key: 'gameIds', label: 'Games', listAccessors: [], formAccessors: ['gameIds'] },
      {
        key: 'commission_perc',
        label: 'Commission %',
        listAccessors: ['commission_perc'],
        formAccessors: ['commission_perc'],
      },
      {
        key: 'target_perc',
        label: 'Target %',
        listAccessors: ['target_perc'],
        formAccessors: ['target_perc'],
      },
      {
        key: 'adminTargetNTP',
        label: 'Admin Target NTP',
        listAccessors: ['adminTargetNTP'],
        formAccessors: ['adminTargetNTP'],
      },
    ],
  },
  {
    entity: 'player',
    label: 'Player',
    color: '#f0fff4',
    fields: [
      { key: 'username', label: 'Username', listAccessors: ['username'], formAccessors: ['username'] },
      { key: 'password', label: 'Password', listAccessors: ['password'], formAccessors: ['password'] },
      { key: 'agent', label: 'Agent', listAccessors: ['agent_name'], formAccessors: ['agent_id'] },
      { key: 'stokez', label: 'Stokez', listAccessors: ['stokez_name'], formAccessors: ['stokez_id'] },
      {
        key: 'super_stokez',
        label: 'Super Stokez',
        listAccessors: ['super_stokez_name'],
        formAccessors: ['super_stokez_id'],
      },
      { key: 'admin', label: 'Admin', listAccessors: ['admin_name'], formAccessors: ['admin_id'] },
      { key: 'company', label: 'Company', listAccessors: ['company_name'], formAccessors: ['company_id'] },
      { key: 'balance', label: 'Balance', listAccessors: ['balance'], formAccessors: ['balance'] },
      { key: 'game_codes', label: 'Game Codes', listAccessors: ['game_codes'], formAccessors: [] },
      { key: 'gameIds', label: 'Games', listAccessors: [], formAccessors: ['gameIds'] },
      {
        key: 'commission_perc',
        label: 'Commission %',
        listAccessors: ['commission_perc'],
        formAccessors: ['commission_perc'],
      },
      {
        key: 'target_perc',
        label: 'Target %',
        listAccessors: ['target_perc'],
        formAccessors: ['target_perc'],
      },
      {
        key: 'adminTargetNTP',
        label: 'Admin Target NTP',
        listAccessors: ['adminTargetNTP'],
        formAccessors: ['adminTargetNTP'],
      },
      { key: 'defaultNTP', label: 'Default NTP', listAccessors: ['defaultNTP'], formAccessors: ['defaultNTP'] },
      { key: 'currentNTP', label: 'Current NTP', listAccessors: ['currentNTP'], formAccessors: ['currentNTP'] },
      { key: 'manual_ntp', label: 'Manual NTP', listAccessors: ['manual_ntp'], formAccessors: ['manual_ntp'] },
      { key: 'allowed_win', label: 'Allowed Win', listAccessors: ['allowed_win'], formAccessors: ['allowed_win'] },
      {
        key: 'default_allowed_win',
        label: 'Default Allowed Win',
        listAccessors: ['default_allowed_win'],
        formAccessors: ['default_allowed_win'],
      },
      {
        key: 'give_manual_win',
        label: 'Give Manual Win',
        listAccessors: ['give_manual_win'],
        formAccessors: ['give_manual_win'],
      },
      {
        key: 'high_limit',
        label: 'High Limit',
        listAccessors: ['high_limit'],
        formAccessors: ['high_limit'],
      },
      {
        key: 'negative_win_limit',
        label: 'Negative Win Limit',
        listAccessors: ['negative_win_limit'],
        formAccessors: ['negative_win_limit'],
      },
      {
        key: 'is_active',
        label: 'Player Status / Active',
        listAccessors: ['is_active'],
        formAccessors: ['is_active'],
      },
      { key: 'isLocked', label: 'Locked', listAccessors: ['isLocked'], formAccessors: ['isLocked'] },
      { key: 'auto_claim', label: 'Auto Claim', listAccessors: ['auto_claim'], formAccessors: ['auto_claim'] },
      { key: 'allow_print', label: 'Allow Print', listAccessors: ['allow_print'], formAccessors: ['allow_print'] },
      {
        key: 'low_chip_enabled',
        label: 'Low Chip',
        listAccessors: ['low_chip_enabled'],
        formAccessors: ['low_chip_enabled'],
      },
      { key: 'winBlock', label: 'Win Block', listAccessors: ['winBlock'], formAccessors: ['winBlock'] },
      { key: 'ntpBlock', label: 'NTP Block', listAccessors: ['ntpBlock'], formAccessors: ['ntpBlock'] },
      { key: 'manualBlock', label: 'Manual Block', listAccessors: ['manualBlock'], formAccessors: ['manualBlock'] },
      { key: 'mac_id', label: 'MAC ID', listAccessors: ['mac_id'], formAccessors: ['mac_id'] },
      {
        key: 'last_login_ip',
        label: 'Last Login IP',
        listAccessors: ['last_login_ip'],
        formAccessors: ['last_login_ip'],
      },
      {
        key: 'last_login_time',
        label: 'Last Login',
        listAccessors: ['last_login_time'],
        formAccessors: ['last_login_time'],
      },
      { key: 'mac_check', label: 'Mac check', listAccessors: ['mac_check'], formAccessors: ['mac_check'] },
      { key: 'status', label: 'Login Status', listAccessors: ['status'], formAccessors: ['status'] },
      { key: 'created_at', label: 'Created', listAccessors: ['created_at'], formAccessors: [] },
      { key: 'updated_at', label: 'Updated', listAccessors: ['updated_at'], formAccessors: [] },
    ],
  },
  // ——— Reports (list view only) ———
  {
    entity: 'reportSummary',
    label: 'Summary Report',
    color: '#fffff0',
    listOnly: true,
    fields: [
      { key: 'player', label: 'Player', listAccessors: ['_id'], formAccessors: [] },
      { key: 'hl', label: 'H/L', listAccessors: ['__hl'], formAccessors: [] },
      { key: 'sale', label: 'Sale', listAccessors: ['Sales'], formAccessors: [] },
      { key: 'win', label: 'Win', listAccessors: ['win'], formAccessors: [] },
      { key: 'gross', label: 'Gross', listAccessors: ['gross'], formAccessors: [] },
      { key: 'playerComm', label: 'Player Comm', listAccessors: ['playerComm'], formAccessors: [] },
      { key: 'n2p', label: 'N2P', listAccessors: ['n2p'], formAccessors: [] },
      { key: 'perc', label: 'Perc', listAccessors: ['current_perc'], formAccessors: [] },
      { key: 'balance', label: 'Balance', listAccessors: ['balance'], formAccessors: [] },
    ],
  },
  {
    entity: 'reportAllTicket',
    label: 'All Ticket Report',
    color: '#fffff0',
    listOnly: true,
    fields: [
      { key: 'ticket_id', label: 'Ticket ID', listAccessors: ['ticket_id'], formAccessors: [] },
      { key: 'draw_id', label: 'Draw ID', listAccessors: ['draw_id'], formAccessors: [] },
      { key: 'draw_time', label: 'Draw Time', listAccessors: ['draw_time'], formAccessors: [] },
      { key: 'total_points', label: 'Total Points', listAccessors: ['total_points'], formAccessors: [] },
      { key: 'win_points', label: 'Win Points', listAccessors: ['win_points'], formAccessors: [] },
      { key: 'status', label: 'Status', listAccessors: ['status'], formAccessors: [] },
      { key: 'entry_time', label: 'Entry Time', listAccessors: ['entry_time'], formAccessors: [] },
    ],
  },
  {
    entity: 'reportHierarchy',
    label: 'Hierarchy Sale Report (SS / Stokez / Agent)',
    color: '#fffff0',
    listOnly: true,
    fields: [
      { key: 'UserID', label: 'User ID', listAccessors: ['UserID'], formAccessors: [] },
      { key: 'Sale', label: 'Sale', listAccessors: ['Sale'], formAccessors: [] },
      { key: 'Win', label: 'Win', listAccessors: ['Win'], formAccessors: [] },
      { key: 'Comm', label: 'Commission', listAccessors: ['Comm'], formAccessors: [] },
      { key: 'NTP', label: 'NTP', listAccessors: ['NTP'], formAccessors: [] },
      { key: 'Optr', label: 'Optr', listAccessors: ['Optr'], formAccessors: [] },
    ],
  },
  {
    entity: 'reportPlayerWise',
    label: 'Player Wise Sale Report',
    color: '#fffff0',
    listOnly: true,
    fields: [
      { key: 'player', label: 'Player', listAccessors: ['_id'], formAccessors: [] },
      {
        key: 'salesWithCancel',
        label: 'Sales With Cancel',
        listAccessors: ['salesWithCancel'],
        formAccessors: [],
      },
      { key: 'cancelled', label: 'Cancel', listAccessors: ['cancelled'], formAccessors: [] },
      { key: 'sale', label: 'Sales', listAccessors: ['Sales'], formAccessors: [] },
      { key: 'win', label: 'Win', listAccessors: ['win'], formAccessors: [] },
      { key: 'gross', label: 'Gross', listAccessors: ['gross'], formAccessors: [] },
      { key: 'playerComm', label: 'Player Comm', listAccessors: ['playerComm'], formAccessors: [] },
      { key: 'n2p', label: 'N2P', listAccessors: ['n2p'], formAccessors: [] },
      { key: 'perc', label: 'Perc', listAccessors: ['current_perc'], formAccessors: [] },
      { key: 'balance', label: 'Balance', listAccessors: ['balance'], formAccessors: [] },
      { key: 'target_perc', label: 'C/M2p', listAccessors: ['target_perc'], formAccessors: [] },
    ],
  },
  {
    entity: 'reportGameWise',
    label: 'Game Wise Sale Report',
    color: '#fffff0',
    listOnly: true,
    fields: [
      { key: 'game_name', label: 'Game Name', listAccessors: ['game_name'], formAccessors: [] },
      { key: 'sales', label: 'Sales', listAccessors: ['sales'], formAccessors: [] },
      { key: 'claimed', label: 'Claimed', listAccessors: ['claimed'], formAccessors: [] },
      { key: 'unclaimed', label: 'UnClaim', listAccessors: ['unclaimed'], formAccessors: [] },
      {
        key: 'cancelledAmount',
        label: 'Cancelled',
        listAccessors: ['cancelledAmount'],
        formAccessors: [],
      },
      {
        key: 'cancelledCount',
        label: 'Cancelled Count',
        listAccessors: ['cancelledCount'],
        formAccessors: [],
      },
      { key: 'profit', label: 'Profit', listAccessors: ['profit'], formAccessors: [] },
    ],
  },
  {
    entity: 'reportDateWise',
    label: 'Date Wise Sale Report',
    color: '#fffff0',
    listOnly: true,
    fields: [
      { key: 'date', label: 'Date', listAccessors: ['_reportDateRange'], formAccessors: [] },
      { key: 'Sale', label: 'Sale', listAccessors: ['Sale'], formAccessors: [] },
      { key: 'Win', label: 'Win', listAccessors: ['Win'], formAccessors: [] },
      { key: 'Comm', label: 'Commission', listAccessors: ['Comm'], formAccessors: [] },
      { key: 'NTP', label: 'Profit', listAccessors: ['NTP'], formAccessors: [] },
    ],
  },
  {
    entity: 'reportTransaction',
    label: 'Transaction Report',
    color: '#fffff0',
    listOnly: true,
    fields: [
      { key: 'slno', label: 'SL NO', listAccessors: ['slno'], formAccessors: [] },
      { key: 'transTime', label: 'Trans Time', listAccessors: ['transTime'], formAccessors: [] },
      { key: 'credit_id', label: 'Credit ID', listAccessors: ['credit_id'], formAccessors: [] },
      { key: 'debit_id', label: 'Debit ID', listAccessors: ['debit_id'], formAccessors: [] },
      { key: 'balance_trans', label: 'Points', listAccessors: ['balance_trans', 'points'], formAccessors: [] },
      {
        key: 'curr_balance',
        label: 'Curr Balance',
        listAccessors: ['curr_balance'],
        formAccessors: [],
      },
      { key: 'transferBy', label: 'Transfer By', listAccessors: ['transferBy', 'transfer_by'], formAccessors: [] },
    ],
  },
  {
    entity: 'reportActivityLog',
    label: 'Activity Log',
    color: '#edf2f7',
    listOnly: true,
    fields: [
      { key: 'slno', label: 'SL NO', listAccessors: ['slno'], formAccessors: [] },
      { key: 'user_id', label: 'User ID', listAccessors: ['user_id'], formAccessors: [] },
      { key: 'log_date', label: 'Log Date', listAccessors: ['log_date'], formAccessors: [] },
      { key: 'log_time', label: 'Log Time', listAccessors: ['log_time'], formAccessors: [] },
      { key: 'activity', label: 'Activity', listAccessors: ['activity'], formAccessors: [] },
      { key: 'win_amount', label: 'Win Amount', listAccessors: ['win_amount'], formAccessors: [] },
    ],
  },
];

export function findFieldDef(entity, accessor) {
  const group = FIELD_CATALOG.find((e) => e.entity === entity);
  if (!group) return null;
  return (
    group.fields.find(
      (f) =>
        f.key === accessor ||
        (f.listAccessors || []).includes(accessor) ||
        (f.formAccessors || []).includes(accessor)
    ) || null
  );
}

export function isFieldVisible(fieldPrivileges, entity, accessor, view) {
  if (!accessor || accessor === 'actions' || accessor === '__actions') return true;
  const def = findFieldDef(entity, accessor);
  if (!def) return true;
  const cell = fieldPrivileges?.[entity]?.[def.key];
  if (!cell) return true;
  if (view === 'list') return cell.list !== false;
  if (view === 'form') return cell.form !== false;
  return true;
}

export function allFieldsTrueMap() {
  const map = {};
  FIELD_CATALOG.forEach((entity) => {
    map[entity.entity] = {};
    entity.fields.forEach((f) => {
      map[entity.entity][f.key] = { list: true, form: true };
    });
  });
  return map;
}
